import {useEffect, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../../utils/commonUrl";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CoreAssessmentChart = ({quarterID}) =>{
    const [competencyAvgData, setCompetencyAvgData] = useState([])

    useEffect(()=>{
        GetCompetencyAvgData(quarterID)
    },[quarterID])

    const GetCompetencyAvgData = (id) => {
        id = parseInt(id) < 0 ? 0 : id;
        axios.post(BASE_URL + `/api/dashboard/GetCompetencyAvgData/${id}`)
            .then(response => {
                setCompetencyAvgData(response.data)
            }).catch(console.error)
    }

    const _yData = competencyAvgData.map((data) => data.competencyName);
  const _dataValue = competencyAvgData.map((data) => data.avgWeight);

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Core Competency",
    },
    xAxis: {
      type: "category",
      labels: {
        rotation: -25,
        style: {
          fontSize: "13px",
          fontFamily: `'Poppins', sans-serif`,
        },
      },
      categories: _yData,
    },
    yAxis: {
      min: 1,
      title: {
        text: "Weight",
      },
    },
    plotOptions: {
        column: {
            colorByPoint: true
        }
    },
    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "Core Assessment: <b>{point.y:.1f}</b>",
    },
    series: [
      {
        name: "Core Assessment",
        data: _dataValue,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
export default CoreAssessmentChart;